"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var lodashGet = require('lodash.get');

var _config; // TODO(Connor): make this default value be a private symbol instead
// TODO(Connor): make this use an init boolean flag instead of empty config


var get = function get(keyLookup) {
  var default_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '__NOT_SET__';
  var iam = 'configment_browser.get()';
  if (!_config) init();
  if (!keyLookup) return _config;
  var val = lodashGet(_config, keyLookup, null);
  if (val !== null) return val;
  if (default_ !== '__NOT_SET__') return default_;
  throw Error("".concat(iam, ": lookup for required config not found: ").concat(keyLookup));
};

var init = function init(config) {
  var iam = 'configment_browser.init()';

  if (config !== undefined) {
    _config = config;
  } else if (typeof window !== 'undefined') {
    _config = window.CONFIGS;
  } else {
    try {
      // server side rendering needs this when you don't compile server code
      eval('_config = process.configment'); // eslint-disable-line no-eval
    } catch (e) {}
  }

  if (_typeof(_config) !== 'object') throw new Error("".concat(iam, ": could not find suitable configs"));
};

module.exports = {
  init: init,
  get: get
};
